import { Accordion, Button, Form, InputGroup, Row } from "react-bootstrap";
import DynamicDrinksList from "./DynamicDrinkList";
import { item } from "./types";
import { useEffect, useState } from "react";
import Papa from "papaparse";
import { isConstructorDeclaration } from "typescript";
import { useHotkeys } from "react-hotkeys-hook";
import PrismaticBurst from "../PrismaticBurst";

const convertToDrinkArr = (parsedResult: Papa.ParseResult<any>): item[] => {
  let result: item[] = [];
  parsedResult.data.shift();
  parsedResult.data.map((row) => {
    let item: item = {
      menuNum: row[0],
      title: row[1],
      sponsor: row[2],
      notes: row[3],
      desc: row[4],
      brewery: row[5],
      abv: row[6],
      type: row[7],
      location: row[8],
      highlight: 0,
    };
    result.push(item);
  });
  return result;
};

const DrinksList = () => {
  const [items, setItems] = useState<item[]>([]);
  const [lock, setLock] = useState<boolean>(false);

  useEffect(() => {
    fetch("/data/items.csv")
      .then((response) => response.text())
      .then((responseText) => {
        const parsedData = Papa.parse<any>(responseText);
        let items = convertToDrinkArr(parsedData);
        setItems(items);
      });
  }, []);

  const resetHighlight = () => {
    setTimeout(() => {
      setItems(
        items.map((item) => {
          item.highlight = 0;
          return item;
        })
      );
    }, 10000);
  };

  const randomPicker = () => {
    if (lock) {
      return;
    }
    let count = 1;
    const BOUNCES = 25;
    const interval = setInterval(() => {
      let tempHighlight = Math.floor(Math.random() * (items.length - 1));
      setItems(
        items.map((item, i) => {
          if (i == tempHighlight) {
            if (count >= BOUNCES) {
              item.highlight = 2;
            } else {
              item.highlight = 1;
            }
            return item;
          } else {
            item.highlight = 0;
            return item;
          }
        })
      );
      if (count >= BOUNCES) {
        clearInterval(interval);
        setLock(false);
        resetHighlight();
      }
      count++;
    }, 100);
    setLock(true);
  };

  useHotkeys("enter", randomPicker);

  return (
    <div style={{top: "10%", position: "absolute"}}>
      <h2 style={{ textAlign: "center", fontSize: "60px"}}>
        Can't decide? <br />
        PRESS THE RED BUTTON!!!
      </h2>
      <DynamicDrinksList items={items}/>
    </div>
  );
};

export default DrinksList;
